import { createSlice } from "@reduxjs/toolkit";
import { getRebates, getRebatesPNL } from "./thunk";
export const initialState = {
  // Get Rebates
  rebateList: [],
  isRebateListSuccess: false,
  // Get PNL Share Rebates
  rebateListPNL: [],
  isRebatePNLListSuccess: false,
  // Error Handling
  error: {},
};

const RebateSlice = createSlice({
  name: "RebateSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get Rebates
    builder.addCase(getRebates.fulfilled, (state: any, action: any) => {
      state.rebateList = action.payload;
      state.isRebateListSuccess = true;
    });
    builder.addCase(getRebates.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
    });
    // Get PNL Share Rebates
    builder.addCase(getRebatesPNL.fulfilled, (state: any, action: any) => {
      state.rebateListPNL = action.payload;
      state.isRebatePNLListSuccess = true;
    });
    builder.addCase(getRebatesPNL.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
    });
  },
});

export default RebateSlice.reducer;
